import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the OfficialDataProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OfficialDataProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello OfficialDataProvider Provider');
  }

  getOfficialAutoList() {
    return this.http.hPost('/get_official_replay_list');
  }

  switchFuncOfficialReply(is_switch: boolean) {
    return this.http.hPost('/switch_official_replay', { switch: is_switch });
  }

  deleteOfficialAutoReply(keywords_id) {
    return this.http.hPost('/delete_official_replay', {
      keywords_id: keywords_id,
    });
  }

  createOfficialAutoReply(
    chatroom_list,
    message_list,
    keyword_list,
    keywords_id
  ) {
    let params = {
      chatroom_list: chatroom_list,
      message_list: message_list,
      keyword_list: keyword_list,
      keywords_id: keywords_id,
    };
    return this.http.hPost('/reply/create_a_auto_reply_setting', params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/official-data/official-data.ts